import FluxUtils from 'flux/utils';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import 'sharedreact/stores/LoggingStore';
import 'workspaces/launcher/data/RegisterClasses';
import 'workspaces/launcher/stores/LoggingStore';

import AboutActions from 'sharedreact/actions/AboutActions';
import AuthenticationActions from 'sharedreact/actions/AuthenticationActions';
import LoggingActions from 'sharedreact/actions/LoggingActions';
import SettingsActions from 'sharedreact/actions/SettingsActions';
import TablePreferencesActions from 'sharedreact/actions/TablePreferencesActions';
import WebAppsActions from 'sharedreact/actions/WebAppsActions';
import withDragDropContext from 'sharedreact/components/withDragDropContext';
import AuthenticationStore from 'sharedreact/stores/AuthenticationStore';
import SettingsStore from 'sharedreact/stores/SettingsStore';
import TablePreferencesStore from 'sharedreact/stores/TablePreferencesStore';
import WebAppsStore from 'sharedreact/stores/WebAppsStore';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';
import LanguageSupport from 'sharedreact/utils/LanguageSupport';
import { assertNonNullish } from 'sharedreact/utils/TypeSupport';

import App from 'workspaces/launcher/App';

import AuthenticationLauncherActions from 'workspaces/launcher/actions/AuthenticationLauncherActions';
import ServerInfoStore from 'workspaces/launcher/stores/ServerInfoStore';

import __BUILD_VERSION__ from 'workspaces/launcher/utils/BuildVersion';
import { StaticContext } from 'react-router';
import LocationState from 'sharedreact/utils/LocationState';

type Props = RouteComponentProps<{}, StaticContext, LocationState> & {
}

type State = ConstructorParameters<typeof App>[0];

function getStores () {
  return [
    AuthenticationStore,
    SettingsStore,
    WebAppsStore,
    ServerInfoStore
  ];
}

function handleShowELearning () {
  window.open('https://learning.esko.com/course/view.php?id=98');
}

function handleShowDocumentation () {
  window.open('https://www.esko.com/Support/Product?id=Automation%20Engine');
}

function handleShowAbout () {
  AboutActions.fetch();
  AboutActions.getLegalNotices();
  AboutActions.showAbout();
}

function handleWindowBlur () {
  if (AuthenticationStore.isLoggedIn()) {
    setTimeout(() => {
      if (AuthenticationStore.isLoggedIn()) {
        TablePreferencesActions.save(TablePreferencesStore.getState());
      }
    });
  }
}

function handleWindowBeforeUnload () {
  if (AuthenticationStore.isLoggedIn()) {
    setTimeout(() => {
      if (AuthenticationStore.isLoggedIn()) {
        TablePreferencesActions.save(TablePreferencesStore.getState());
      }
    });
  }
}

const LANGUAGE_FILES_FOLDER: string = '../static/properties/' + __BUILD_VERSION__ + '/';

function handleUnauthorized () {
  AuthenticationActions.handleUnauthorized(AuthenticationLauncherActions.doPostLogoutCleanup);
}

function initialize () {
  ConnectionSupport.setLogger(LoggingActions.log);
  ConnectionSupport.setUnauthorizedHandler(handleUnauthorized);

  window.addEventListener('blur', handleWindowBlur);
  window.addEventListener('beforeunload', handleWindowBeforeUnload);

  ConnectionSupport.setServicesSubFolder('services/webappslauncher/actions/');
  LanguageSupport.setLanguageBaseFiles(
    LANGUAGE_FILES_FOLDER + 'launcher',
    LANGUAGE_FILES_FOLDER + 'shared',
    LANGUAGE_FILES_FOLDER + 'audit',
    LANGUAGE_FILES_FOLDER + 'common',
    LANGUAGE_FILES_FOLDER + 'fileinfo'
  );

  AuthenticationActions.relogin(AuthenticationLauncherActions.doPostLoginInit);
}

function finalize () {
  AuthenticationLauncherActions.doPostLogoutCleanup();
}

function calculateState (prevState?: State, props?: Props): State {
  assertNonNullish(props);

  AuthenticationLauncherActions.setDebugEvents(SettingsStore.getSettings().logToConsole, SettingsStore.getSettings().logHeartBeatEvents);

  return {
    location: props.location,
    language: SettingsStore.getLanguage(),
    theme: SettingsStore.getSettings().theme,
    font: SettingsStore.getSettings().font,
    isLoggedIn: AuthenticationStore.isLoggedIn(),
    userSettingsLoaded: SettingsStore.areUserSettingsLoaded(),
    activeUser: AuthenticationStore.getUser(),
    attemptRelogin: AuthenticationStore.isAttemptRelogin(),
    toggleSettings: SettingsActions.toggle,
    toggleAccount: AuthenticationActions.toggleSlideOut,
    onShowELearning: handleShowELearning,
    onShowDocumentation: handleShowDocumentation,
    onShowAbout: handleShowAbout,
    onShowAppLauncher: () => WebAppsActions.show('Home', '/'),
    onLoad: initialize,
    onUnload: finalize,
    hasWorkspaces: WebAppsStore.getItems().size > 0
  };
}

export default withRouter(
  FluxUtils.Container.createFunctional(
    withDragDropContext(App),
    getStores,
    calculateState,
    { withProps: true }
  )
);
